import React from 'react';
import { Plus, RotateCcw, Save, Edit2, X } from 'lucide-react';

interface DashboardToolbarProps {
  isEditing: boolean;
  onToggleEdit: () => void;
  onAddWidget: () => void;
  onResetLayout: () => void;
  onSave: () => void;
  isSaving?: boolean;
}

const DashboardToolbar: React.FC<DashboardToolbarProps> = ({
  isEditing,
  onToggleEdit,
  onAddWidget,
  onResetLayout,
  onSave,
  isSaving = false
}) => {
  return (
    <div className="flex items-center justify-between mb-6 p-4 bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700">
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Dashboard</h1>
        <p className="text-sm text-gray-500">Personalize seu painel de controle</p>
      </div>
      <div className="flex items-center gap-2">
        {isEditing ? (
          <>
            <button
              onClick={onAddWidget}
              className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
            >
              <Plus className="h-4 w-4" />
              Adicionar Widget
            </button>
            <button
              onClick={onResetLayout}
              className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              <RotateCcw className="h-4 w-4" />
              Resetar
            </button>
            <button
              onClick={onSave}
              disabled={isSaving}
              className="flex items-center gap-2 px-4 py-2 bg-success-600 text-white rounded-lg hover:bg-success-700 transition-colors disabled:opacity-50"
            >
              <Save className="h-4 w-4" />
              {isSaving ? 'Salvando...' : 'Salvar'}
            </button>
            <button
              onClick={onToggleEdit}
              className="flex items-center gap-2 px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition-colors"
            >
              <X className="h-4 w-4" />
              Cancelar
            </button>
          </>
        ) : (
          <button
            onClick={onToggleEdit}
            className="flex items-center gap-2 px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors"
          >
            <Edit2 className="h-4 w-4" />
            Editar Dashboard
          </button>
        )}
      </div>
    </div>
  );
};

export default DashboardToolbar;





